<template>
    <div class="thermometer">
        <svg viewBox="0 0 36 36" class="circular-chart">
            <path class="circle-bg" d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831" />
            <path class="circle" :stroke="circleColor" :stroke-dasharray="`${percentage}, 100`" d="M18 2.0845
             a 15.9155 15.9155 0 0 1 0 31.831
             a 15.9155 15.9155 0 0 1 0 -31.831" />
            <text x="18" y="20.35" class="percentage">{{ value }}</text>
        </svg>
        <div class="title">{{ title }}</div>
    </div>
</template>

<script>
export default {
    name: "Thermometer",
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            required: true
        }
    },
    computed: {
        percentage() {
            // Convert the value from -100 to 100 to a percentage from 0 to 100
            return ((this.value + 100) / 200) * 100;
        },
        circleColor() {
            if (this.value >= -100 && this.value <= -1) {
                return "#FF7B7B";
            } else if (this.value >= 0 && this.value <= 39) {
                return "#FFCA02";
            } else if (this.value >= 40 && this.value <= 100) {
                return "#00542E";
            }
            return "red";
        }
    }
};
</script>

<style scoped>
.thermometer {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.circular-chart {
    max-width: 100px;
    max-height: 100px;
}

.circle-bg {
    fill: none;
    stroke: #eee;
    stroke-width: 3.8;
}

.circle {
    fill: none;
    stroke-width: 2.8;
    stroke-linecap: round;
    transition: stroke-dasharray 0.3s ease, stroke 0.3s ease;
}

.percentage {
    fill: #333;
    font-size: 0.5em;
    text-anchor: middle;
}

.title {
    margin-top: 10px;
    font-size: 1em;
    text-align: center;
}
</style>
